import { render, staticRenderFns } from "./nation.vue?vue&type=template&id=12a41546&scoped=true&"
import script from "./nation.vue?vue&type=script&lang=js&"
export * from "./nation.vue?vue&type=script&lang=js&"
import style0 from "./nation.vue?vue&type=style&index=0&id=12a41546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a41546",
  null
  
)

export default component.exports